import { render, staticRenderFns } from "./ClinicOrderComplete.vue?vue&type=template&id=29829342&scoped=true&"
import script from "./ClinicOrderComplete.vue?vue&type=script&lang=js&"
export * from "./ClinicOrderComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29829342",
  null
  
)

export default component.exports